import choVayConst from "constants/choVayConst";
import { LaiSuatText } from "constants/choVayConst";
import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import CauHinhApi from "service/cauHinhApi";
import {
  LAI_TRA_GOP_TRIEU_NGAY,
  laiDonViRaLaiTrieuNgay,
} from "utils/laiTraGop";
class ChiTietChoVaySub extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
      laiTraGop: 0,
      anDinhNgayThangTraGop: false,
    };
  }

  componentDidMount() {
    this.napCauHinhTraGop();
  }

  componentDidUpdate() {
    this.napCauHinhTraGop();
  }

  napCauHinhTraGop() {
    let { data } = this.props;
    if (this.daNapCauHinhTraGop || !data || data.Type !== 2) return;
    this.daNapCauHinhTraGop = true;
    CauHinhApi.getConfigSys_TraGop().then((response) => {
      if (response.ok && response.data) {
        this.setState({
          laiTraGop: response.data._laiTraGop,
          anDinhNgayThangTraGop: response.data._anDinhNgayThangTraGop === true,
        });
      }
    });
  }

  render() {
    let { data, TongTienGoc, isCauHinhKhachHangVSNY } = this.props;
    let { laiTraGop, anDinhNgayThangTraGop } = this.state;
    const laiSuatThuLaiSauTraGop =
      laiTraGop === LAI_TRA_GOP_TRIEU_NGAY
        ? formatNumber(
            Math.round(
              laiDonViRaLaiTrieuNgay(
                data.ValueLai,
                data.Sotienvay,
                data.TypePaid !== 1 || anDinhNgayThangTraGop,
              ),
            ),
          ) + "đ/triệu/ngày"
        : formatNumber(Math.ceil(data.ValueLai * data.BocTrongVong)) + "đ";
    return (
      <>
        <div class="from-thongtintra" style={{ marginTop: "10px" }}>
          <p>
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                {" "}
                Thanh toán cho hợp đồng:{" "}
              </div>
              <div className="col-3 text-left  text-normal color7">
                <span className="color-xanh-bold">{data.Code}</span>
              </div>
            </div>
          </p>
          <p>
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Tên khách hàng:{" "}
              </div>
              <div className="col-3 text-left  text-normal color7">
                <span>{data.CustomerName}</span>
              </div>
            </div>
          </p>
          <p>
            {isCauHinhKhachHangVSNY == false && (
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Ngày sinh:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{data.YearBirth}</span>
                </div>
              </div>
            )}
            {isCauHinhKhachHangVSNY == true && (
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Số điện thoại:{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{data.phoneCus}</span>
                </div>
              </div>
            )}
          </p>
          <p>
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Địa chỉ:{" "}
              </div>
              <div className="col-3 text-left  text-normal color7">
                <span>{data.YeCustomerAddressarBirth}</span>
              </div>
            </div>
          </p>
        </div>
        <div class="from-thongtintra">
          <p>
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Số tiền vay:
              </div>
              <div className="col-3 text-left  text-normal color7">
                <span className="color-do-bold">
                  {" "}
                  {formatNumber(
                    TongTienGoc
                      ? TongTienGoc
                      : data.SoTienVayConLai
                        ? data.SoTienVayConLai
                        : data.Sotienvay,
                  )}
                </span>
              </div>
            </div>
          </p>
          <p>
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Ngày vay:
              </div>
              <div className="col-3 text-left  text-normal color7">
                <span>{getDate(data.NgayVay)}</span>
              </div>
            </div>
          </p>
          {isCauHinhKhachHangVSNY == true && (
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  {" "}
                  Ngày thanh toán (chu kỳ 30 ngày) :{" "}
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{getDate(data.NgayTraLaiTiepTheo)}</span>
                </div>
              </div>
            </p>
          )}
          {data.Type == 1 && isCauHinhKhachHangVSNY == false && (
            <p>
              <div className="row">
                <div className="col-label-thong-tin-hd color7-bold">
                  Phí Phạt:
                </div>
                <div className="col-3 text-left  text-normal color7">
                  <span>{getDate(data.NgayVay)}</span>
                </div>
              </div>
            </p>
          )}
          {isCauHinhKhachHangVSNY == true && (
            <>
              {data.Type !== 2 && (
                <p>
                  <div className="row">
                    <div className="col-label-thong-tin-hd color7-bold">
                      Lãi/phí:
                    </div>
                    <div className="col-3 text-left  text-normal color7">
                      <span className="color-cam-bold">
                        {" "}
                        {data.StatusPaidHo !== 3 && (
                          <>
                            {choVayConst.KieuLaiSuatText[data.KieuLaiSuat]}:{" "}
                            {LaiSuatText(data, data.KieuLaiSuat)}
                          </>
                        )}
                        {data.StatusPaidHo === 3 &&
                          data.ChiPhiVay.toFixed(2) + "%"}
                      </span>
                    </div>
                  </div>
                </p>
              )}
              {data.Type === 2 && (
                <p>
                  <div className="row">
                    <div className="col-label-thong-tin-hd color7-bold">
                      Lãi/phí:
                    </div>
                    <div className="col-3 text-left  text-normal color7">
                      <span className="color-cam-bold">
                        {" "}
                        {data.StatusPaidHo === 1 &&
                          formatNumber(
                            Math.ceil(data.ValueLai * data.CountTypePaid),
                          ) + "đ"}
                        {data.StatusPaidHo === 2 && laiSuatThuLaiSauTraGop}
                        {data.StatusPaidHo === 3 &&
                          data.ChiPhiVay.toFixed(2) + "%"}
                      </span>
                    </div>
                  </div>
                </p>
              )}
            </>
          )}
          {isCauHinhKhachHangVSNY == false && (
            <>
              {data.Type !== 2 && (
                <p>
                  <div className="row">
                    <div className="col-label-thong-tin-hd color7-bold">
                      Lãi suất:
                    </div>
                    <div className="col-3 text-left  text-normal color7">
                      <span className="color-cam-bold">
                        {" "}
                        {data.StatusPaidHo !== 3 && (
                          <>
                            {choVayConst.KieuLaiSuatText[data.KieuLaiSuat]}:{" "}
                            {LaiSuatText(data, data.KieuLaiSuat)}
                          </>
                        )}
                        {data.StatusPaidHo === 3 &&
                          data.ChiPhiVay.toFixed(2) + "%"}
                      </span>
                    </div>
                  </div>
                </p>
              )}
              {data.Type === 2 && (
                <p>
                  <div className="row">
                    <div className="col-label-thong-tin-hd color7-bold">
                      Lãi suất:
                    </div>
                    <div className="col-3 text-left  text-normal color7">
                      <span className="color-cam-bold">
                        {" "}
                        {data.StatusPaidHo === 1 &&
                          formatNumber(
                            Math.ceil(data.ValueLai * data.CountTypePaid),
                          ) + "đ"}
                        {data.StatusPaidHo === 2 && laiSuatThuLaiSauTraGop}
                        {data.StatusPaidHo === 3 &&
                          data.ChiPhiVay.toFixed(2) + "%"}
                      </span>
                    </div>
                  </div>
                </p>
              )}
            </>
          )}
          <p>
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Kiểu vay:
              </div>
              <div className="col-3 text-left  text-normal color7">
                <span>{choVayConst.TypeText[data.Type]}</span>
              </div>
            </div>
          </p>
        </div>
      </>
    );
  }
}
export default ChiTietChoVaySub;
